import React, { useRef, useState } from 'react';
import { GA_EVENTS, trackEvent } from '../../utils/analytics';

const clamp = (value) => Math.max(0, Math.min(100, value));

/**
 * Draggable before/after comparison (pointer, touch and keyboard).
 */
export default function BeforeAfterSlider({ before, after, rows, source = 'home_case_aws' }) {
  const ref = useRef(null);
  const tracked = useRef(false);
  const [position, setPosition] = useState(50);
  const [dragging, setDragging] = useState(false);

  const trackOnce = () => {
    if (tracked.current) return;
    tracked.current = true;
    trackEvent(GA_EVENTS.INTERACCION_COMPARADOR, { source });
  };

  const updateFromEvent = (event) => {
    const rect = ref.current.getBoundingClientRect();
    setPosition(clamp(((event.clientX - rect.left) / rect.width) * 100));
  };

  const handlePointerDown = (event) => {
    setDragging(true);
    ref.current.setPointerCapture(event.pointerId);
    updateFromEvent(event);
    trackOnce();
  };

  const handleKeyDown = (event) => {
    const steps = { ArrowLeft: -5, ArrowRight: 5, Home: -100, End: 100 };
    if (!(event.key in steps)) return;
    event.preventDefault();
    setPosition((current) => clamp(current + steps[event.key]));
    trackOnce();
  };

  const renderLayer = (side, data) => (
    <div className={`home-compare-layer home-compare-layer--${side}`} aria-hidden={side === 'after' ? 'true' : undefined}>
      <div className="home-compare-title">
        <span>{side === 'before' ? data.label : ''}</span>
        <span>{side === 'after' ? data.label : ''}</span>
      </div>
      {rows.map((row) => (
        <div key={row.label} className="home-compare-row">
          <span>{row.label}</span>
          <div style={{ width: `${row[side].width}%` }} />
          <em>{row[side].status}</em>
        </div>
      ))}
      <div className="home-compare-total">
        <span>Total mensual</span>
        <span>{data.total}</span>
      </div>
    </div>
  );

  return (
    <div
      ref={ref}
      className={`home-compare ${dragging ? 'is-dragging' : ''}`}
      style={{ '--compare-pos': `${position}%` }}
      onPointerDown={handlePointerDown}
      onPointerMove={(event) => dragging && updateFromEvent(event)}
      onPointerUp={() => setDragging(false)}
      onPointerCancel={() => setDragging(false)}
    >
      {renderLayer('before', before)}
      {renderLayer('after', after)}
      <div
        className="home-compare-handle"
        role="slider"
        tabIndex={0}
        aria-label="Comparar antes y después de la optimización"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(position)}
        aria-valuetext={`${before.label} ${before.total}, ${after.label} ${after.total}`}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}
